module.exports = __webpack_public_path__ + "static/img/d4t_pc.ed31ae78.jpg";